var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"margin-top":"30px"}},[_c('h3',[_vm._v("Users")]),_c('Table',{staticStyle:{"margin-top":"15px"},attrs:{"stripe":"","columns":_vm.columns,"data":_vm.users}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }